import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPlaylistPersonalised$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPlaylistPersonalised extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1cdfb965249372aa08c5322bd4397db3fb5b7e5f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e754eb60d6c80704c74fc17d85234a6cbeadad11', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0ba2eb84614883013d86239c2945a62a58db1ca5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 7a5 5 0 1 1 10 0A5 5 0 0 1 2 7m12.5-2a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5h4A.5.5 0 0 0 19 6v-.5a.5.5 0 0 0-.5-.5zm0 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM8 16a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5zM6 4.28a1.3 1.3 0 0 1 1-.4 1.34 1.34 0 0 1 1 .4c.197.248.274.57.21.88l-.12 1.31A1 1 0 0 1 7 7.4a1 1 0 0 1-1.09-.93l-.16-1.32A1 1 0 0 1 6 4.28m-.06 3.86A2 2 0 0 0 4.55 10h4.9a2 2 0 0 0-1.39-1.86 2.29 2.29 0 0 1-2.12 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-playlist-personalised", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-playlist-personalised"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-playlist-personalised":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPlaylistPersonalised$1);
            }
            break;
    } });
}

const CosmosIconPlaylistPersonalised = CosmosIconPlaylistPersonalised$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPlaylistPersonalised, defineCustomElement };
